module.exports = __webpack_public_path__ + "static/img/three.cc0e6ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/ThreeDimensional/three.jpg
// module id = e47W
// module chunks = 12